import { version } from '../../../package.json';
import { PLUGIN_NAME } from './constants';
import pageBuilderComponents from './page-builder-components';

async function load(app) {
  app.events.on('load:custom:page-builder:component', addComponentType => {
    pageBuilderComponents.forEach(component => {
      addComponentType({ type: component.type, component });
    });
  });

  return {
    name: PLUGIN_NAME,
    version
  };
}

load.pluginName = PLUGIN_NAME;

export default load;
